module.exports = __webpack_public_path__ + "img/mirror30.9f3460c6.jpg";